module.exports = __webpack_public_path__ + "static/img/join2.5a0c1b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/join2.png
// module id = FBIt
// module chunks = 24